import { Select, SelectOption, SelectOptionsGroup } from "@clockwise/design-system";
import { RepeatingEventSaveOption } from "@clockwise/schema";
import React from "react";
import { SubmitDeleteSelectCopy } from "../utils/getSubmitButtonCopy";

export const SaveDropdown = ({
  onSelect,
  disabledRecurrenceSaveOptions,
  submissionCopy,
  disabled,
}: {
  disabledRecurrenceSaveOptions: RepeatingEventSaveOption[];
  onSelect: (option: RepeatingEventSaveOption) => void;
  submissionCopy: SubmitDeleteSelectCopy;
  disabled: boolean;
}) => {
  return (
    <Select
      disabled={disabled}
      size="small"
      variant="elevated"
      value={undefined}
      onChange={onSelect}
    >
      <SelectOptionsGroup>
        <SelectOption key="save-event-placeholder" value="">
          {submissionCopy.default}
        </SelectOption>
        <SelectOption
          disabled={disabledRecurrenceSaveOptions.includes(
            RepeatingEventSaveOption.ThisInstanceOnly,
          )}
          value={RepeatingEventSaveOption.ThisInstanceOnly}
        >
          {submissionCopy.singleEventOnly}
        </SelectOption>
        <SelectOption
          disabled={disabledRecurrenceSaveOptions.includes(
            RepeatingEventSaveOption.ThisAndFutureInstances,
          )}
          value={RepeatingEventSaveOption.ThisAndFutureInstances}
        >
          {submissionCopy.thisAndFutureEvents}
        </SelectOption>
        <SelectOption
          disabled={disabledRecurrenceSaveOptions.includes(RepeatingEventSaveOption.AllInstances)}
          value={RepeatingEventSaveOption.AllInstances}
        >
          {submissionCopy.allEvents}
        </SelectOption>
      </SelectOptionsGroup>
    </Select>
  );
};
